const mapCapacity = (capacities, value) => capacities
  .filter(filter => filter.min <= value && filter.max >= value)
  .map(filter => ({ min: filter.min, max: filter.max }));

export default mapCapacity;
